import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useNursing } from "./NursingLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBodyPage() {
  const data = useNursing();
  const list = data.executive_body || [];
  return (
    <div data-testid="nur-eb-page-wrap">
      <PageHero eyebrow="About" title="Executive Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="emerald" testidPrefix="nur-eb-page" />
      </PageBody>
    </div>
  );
}
